// extracted by mini-css-extract-plugin
export default {"LogoPreview":"LogoPreview_LogoPreview__okS8v","LogoPreview__overlay":"LogoPreview_LogoPreview__overlay__QhUR-","LogoPreview__button":"LogoPreview_LogoPreview__button__iWbEF"};